import { BetAreaPanel } from './BetArea';
export const SedieBetAreaPanel = () => {
    return <BetAreaPanel />;
};
